import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFOrdersEntities } from '@pf/shared-common';
import { PurchaseOrderLineRead } from '../../entities/purchase-order-line.dto';

@Injectable()
export class PurchaseOrderLineStore extends AbstractEntityStore<PurchaseOrderLineRead> {
    constructor() {
        super(PFOrdersEntities.PurchaseOrderLine);
    }
}
